import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import BasicHeaderPlayScreen from "../../Header/BasicHeaderPlayScreen";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import star from "../../image/star.png";
import hangman1 from "../../image/hangman/starting.gif";
import hangman2 from "../../image/hangman/HANGMAN-GIF(2)-(2).gif";
import hangman3 from "../../image/hangman/HANGMAN-GIF-(2) (1).gif";
import hangman4 from "../../image/hangman/HANGMAN-GIF-(3) (1).gif";
import hangman5 from "../../image/hangman/HANGMAN-GIF-(4) (1).gif";
import hangman6 from "../../image/hangman/HANGMAN-GIF-(5) (1).gif";
import hangman7 from "../../image/hangman/HANGMAN-GIF-(6) (1).gif";
import nextIcon from "../../image/Vector.png";
import CorrectLetter from "../../Sounds/correct Letter.mp3";
import WrongLetter from "../../Sounds/wrong_guessed.mp3";
import "../../style/HangManPlayScreen.css";
import axios from "axios";
import { size } from "polished";

import firebase from "../../firebase";
import GuessedWordsModal from "../CrowdMode/GuessedWordsModal";
import landscapeIcon from "../../image/landscape-icon.webp";
import { useMobileOrientation } from "react-device-detect";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
// Import alphabet utilities
import { getAlphabetForLanguage, normalizeCharacter, detectLanguageFromWord, isCrowdMode } from "../../utils/alphabetUtils";

const HangManPlayScreen = ({ onNavigate }) => {
  const rounds = useSelector((state) => state.round.rounds);
  const gameName = useSelector((state) => state.gameName.gameName);
  const correctguess = localStorage.getItem('wordToGuess');
  const [students, setStudents] = useState([]);
  const { orientation } = useMobileOrientation();
  const [isportrait, setIsportrait] = useState(false);
  const [wordToGuess, setWordToGuess] = useState("");
  const [guessedLetters, setGuessedLetters] = useState([]);
  const [connectedstudents, setConnectedStudents] = useState([]);
  const [wrongGuesses, setWrongGuesses] = useState(() => {
    const wrongGuesses = localStorage.getItem("wrongGuesses");
    return wrongGuesses ? parseInt(wrongGuesses) : 0;
  });
  //  const [currentTeam, setCurrentTeam] = useState(() => {
  //     const currentTeam = localStorage.getItem('currentTeam');
  //     return (currentTeam  ? parseInt(currentTeam) : null);
  //   });
  const [connectedStudent, setconnectedStudent] = useState([]);
  const localization = useSelector((state) => state.localization.localization);
  const { clid: clid } = useParams();
  // console.log(clid, "clid");
  const isPlayMode = window.location.href.includes("m=play");
  const [isDraw, setIsDraw] = useState(false);
  const [currentTeam, setCurrentTeam] = useState(() => {
    const currentTeam = localStorage.getItem("currentTeam");
    const parsedTeam = currentTeam ? parseInt(currentTeam) : null;

    // Check if the URL contains 'm=play'
    const isPlayMode = window.location.href.includes("m=play");

    // If 'm=play' is in the URL, set `currentTeam` to 0.
    if (isPlayMode) {
      return 0;
    }

    // Otherwise, return the parsed value.
    return parsedTeam;
  });
  const [score, setScore] = useState(() => {
    const storedScore = localStorage.getItem("score");
    return storedScore ? JSON.parse(storedScore) : [0, 0];
  });

  const [showDrawModal, setShowDrawModal] = useState(false); // State for draw modal
  const [showplayaloneModal, setshowplayaloneModal] = useState(false); // State for draw modal
  const [showNextTurnModal, setShowNextTurnModal] = useState(false);
  const [nextTeamName, setNextTeamName] = useState("");
  // const [showTeamSelectModal, setShowTeamSelectModal] = useState(() => {
  //   const currentTeam = localStorage.getItem('currentTeam');
  //   const parsedTeam = parseInt(currentTeam);
  //   return isNaN(parsedTeam) ? true : (parsedTeam ? false : true);
  // });
  const [showTeamSelectModal, setShowTeamSelectModal] = useState(() => {
    const currentTeam = localStorage.getItem("currentTeam");
    const parsedTeam = parseInt(currentTeam);

    // Check if the URL contains 'm=play'
    const isPlayMode = window.location.href.includes("m=play");

    // If 'm=play' is in the URL, set it to false, otherwise evaluate based on parsedTeam.
    if (isPlayMode) {
      return false;
    }

    // Otherwise, fallback to the logic with parsedTeam.
    return isNaN(parsedTeam) ? true : !parsedTeam;
  });
  const [showWinModal, setShowWinModal] = useState(false); // State for win modal
  const [winningTeam, setWinningTeam] = useState(null); // State to track the winning team
  const [roundsData, setRoundsData] = useState([]);

  // Get language from Redux store
  const language = useSelector((state) => state.language?.language || 'en');

  // Auto-detect language from word if available, otherwise use Redux language
  // Now supports Arabic alphabet in crowd mode
  const currentLanguage = wordToGuess && wordToGuess.trim() ? detectLanguageFromWord(wordToGuess) : language;

  // Get alphabet based on detected/selected language
  const alphabet = getAlphabetForLanguage(currentLanguage);
  const code = localStorage.getItem("code");

  // Send word to Firebase whenever it changes (for participants)
  useEffect(() => {
    if (code && wordToGuess) {
      const db = firebase.database();
      const ref = db.ref(`AppleTV/${code}`);
      ref.update({ correctWord: wordToGuess });
      console.log('Updated correctWord in Firebase:', wordToGuess);
    }
  }, [wordToGuess, code]);
  const hangmanImages = [
    hangman1,
    hangman2,
    hangman3,
    hangman4,
    hangman5,
    hangman6,
    hangman7,
  ];
  const [showResultModal, setShowResultModal] = useState(false);
  const fullname = localStorage.getItem("name");
  const [currentScore, setCurrentScore] = useState(0); // State for score
  const backgroundColor = useSelector(
    (state) => state.backgroundColor.backgroundColor
  );
  const fontColor = useSelector((state) => state.fontColor.fontColor);
  const teamNames = useSelector((state) => state.gameSettings.teamNames);
  const team1bgColor = useSelector((state) => state.gameSettings.team1bgColor);
  const team2bgColor = useSelector((state) => state.gameSettings.team2bgColor);
  const buttonColor = useSelector((state) => state.gameSettings.buttonColor);
  const backgroundImg = useSelector(
    (state) => state.backgroundImg.backgroundImg
  );
  const mobile = useSelector(state => state.mobile.isMobile); // Correctly access isMobile
  const backgroundStyle = backgroundImg
    ? {
      backgroundImage: `url(${backgroundImg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      paddingLeft: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
      paddingRight: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
    }
    : {
      backgroundColor,
      paddingLeft: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
      paddingRight: mobile ? '15px' : '0', // 15px if mobile is true, 0 otherwise
    };
  const [displayWord, setDisplayWord] = useState("");
  const [guessedWords, setGuessedWords] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [participantsStartedAnswering, setParticipantsStartedAnswering] =
    useState(false); // Add this state
  const [participants, setParticipants] = useState([]);

  useEffect(() => {
    if (isPlayMode) {
      setshowplayaloneModal(true);
    }
  }, []);
  useEffect(() => {
    // Load the word to guess from local storage
    const savedWord = localStorage.getItem("wordToGuess");
    if (savedWord) {
      setWordToGuess(savedWord);

      // Immediately send the word to Firebase for participants
      if (code) {
        const db = firebase.database();
        const ref = db.ref(`AppleTV/${code}`);
        ref.update({ correctWord: savedWord });
        console.log('Sent correctWord to Firebase on component mount:', savedWord);
      }
    }

    // Load previous round winners from localStorage
    const savedRoundWinners =
      JSON.parse(localStorage.getItem("roundWinners")) || [];
    console.log("Previous round winners:", savedRoundWinners);
  }, []);

  useEffect(() => {
    const fetchConnectedStudents = async () => {
      try {
        const clid = window.location.pathname.split("/").pop(); // Extract the `clid` from the URL
        const response = await axios.get(`https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`);

        // `response.data` already contains the parsed JSON
        const data = response.data;
        const sessionData = Array.isArray(data) ? data : [];
        const currentSession = sessionData[sessionData.length - 1]; // Get the last session

        if (currentSession && currentSession.connectedstudents) {
          setConnectedStudents(currentSession.connectedstudents); // Set the connected students
          console.log("Connected students set:", currentSession.connectedstudents);
        } else {
          console.warn("No matching session found or no connected students available.");
          setConnectedStudents([]);
        }
      } catch (error) {
        console.error("Error fetching connected students:", error);
      }
    };

    fetchConnectedStudents();
  }, []);



  useEffect(() => {
    if (orientation === "portrait") {
      // User is on a mobile device in portrait mode
      setIsportrait(true);
      console.log("Mobile portrait mode detected");
    } else {
      setIsportrait(false);
      console.log("Not mobile portrait mode");
    }
  }, [orientation]);

  // useEffect(() => {
  //   // Redirect to /splash if the game has ended
  //   if (!showWinModal && !showDrawModal && (wrongGuesses >= hangmanImages.length - 1 || winningTeam !== null)) {
  //     window.localStorage.removeItem('wordToGuess');
  //     window.localStorage.removeItem('guessedLetters');
  //     window.localStorage.removeItem('wrongGuesses');
  //     window.localStorage.removeItem('currentTeam');
  //     window.localStorage.removeItem('score');

  //     onNavigate('splash');
  //   }
  // }, [showWinModal, showDrawModal,  wrongGuesses, winningTeam]);

  useEffect(() => {
    // Show the draw modal when the maximum number of wrong guesses is reached
    if (wrongGuesses >= hangmanImages.length - 1) {
      setShowDrawModal(true);
    }
  }, [wrongGuesses]);

  // useEffect(() => {
  //   if (code) {
  //     const db = firebase.database();
  //     const ref = db.ref(`AppleTV/${code}`);
  //     let previousData;

  //     ref.on("value", (snapshot) => {
  //       const data = snapshot.val();
  //       if (data !== previousData) {
  //         previousData = data;

  //         let guessedNames = [];
  //         if (data.guessedWordbyparticipant) {
  //           guessedNames = data.guessedWordbyparticipant.map(
  //             (item) => item.name
  //           );

  //           const guessedWords = data.guessedWordbyparticipant.reduce(
  //             (acc, current) => {
  //               acc[current.guessedword] = (acc[current.guessedword] || 0) +1;
  //               return acc;
  //             },
  //             {}
  //           );

  //           const totalGuessedWords = data.guessedWordbyparticipant.length;
  //           const calculatedGuessedWords = Object.keys(guessedWords).map(
  //             (word) => ({
  //               word,
  //               percentage: (guessedWords[word] / totalGuessedWords) * 100,
  //             })
  //           );

  //           setGuessedWords(calculatedGuessedWords);

  //           if (data.scores) {
  //             const participantName = fullname;
  //             if (data.scores[participantName]) {
  //               setCurrentScore(data.scores[participantName].score);
  //             }
  //           }
  //         }

  //         if (data.participantsStartedAnswering) {
  //           console.log("Setting participantsStartedAnswering to true");
  //           setParticipantsStartedAnswering(true);
  //         }

  //         // Extract `currentTeamName` from the `currentteam` field.
  //         const currentTeamName = data.currentteam || null;

  //         // Filter the `teamNames` to get all teams with the same `allocatedTeam` value.
  //         const teamParticipants =
  //           data.teamNames && currentTeamName
  //             ? data.teamNames
  //                 .filter((team) => team.allocatedTeam === currentTeamName)
  //                 .filter((team) => !guessedNames.includes(team.name)) // Exclude participants whose names are in `guessedNames`
  //                 .map((team) => ({
  //                   initials: team.initials,
  //                   name: team.name,
  //                   profileColor: team.profileColor,
  //                   allocatedTeam: team.allocatedTeam,
  //                 }))
  //             : [];

  //         console.log("Filtered Team Participants:", teamParticipants);

  //         // Set the filtered participants.
  //         setParticipants(teamParticipants);
  //       }
  //     });
  //   }
  // }, [code, participantsStartedAnswering]);

  const fetchGameData = async () => {
    try {
      // Fetch initial game data from Firebase
      const response = await fetch(`https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`);
      if (!response.ok) {
        throw new Error(`Error fetching data: ${response.statusText}`);
      }
      const data = await response.json();
      // setGameData(data);

      // Listen for changes in the students data from Firebase Realtime Database
      const db = firebase.database();
      const ref = db.ref(`AppleTV/${code}/students`);

      // Handle the initial fetch and subsequent updates
      ref.on('value', snapshot => {
        const students = snapshot.val();
        if (Array.isArray(students)) {
          const dynamicStudents = students.map((student, index) => {
            const parts = student.stuname.split(" - ");
            const color = parts[0].split(" ")[1] || "gray";
            const initials = parts[0].split(" ")[0] || "??";
            const name = parts[1] || "Unknown";
            const textColor = color.toLowerCase() === "white" ? "black" : "white";

            return {
              id: student.stuid || index,
              color,
              initials,
              name,
              textColor,
              correctAnswers: student.correctanswers || 0,
              gamesPlayed: student.gameplayed || 0,
              questionsAttempted: student.questionattempted || 0,
              email: student.stuemail || "N/A",
              stupin: student.stupin || "",
            };
          });
          console.log("dynamicStudents", dynamicStudents);
          setStudents(dynamicStudents);
        } else {
          // console.error("Invalid or missing students data:", students);
          setStudents([]);
        }
      });

    } catch (err) {
      console.error("Error fetching game data:", err);

    }
  };

  useEffect(() => {
    // Fetch game data on component mount
    fetchGameData();

    // Cleanup function to remove the Firebase listener when the component unmounts
    return () => {
      const db = firebase.database();
      const ref = db.ref(`AppleTV/${code}/students`);
      ref.off(); // This will remove the listener
    };
  }, [code]);


  useEffect(() => {
    if (code) {
      const db = firebase.database();
      const ref = db.ref(`AppleTV/${code}`);
      let previousData;

      ref.on("value", (snapshot) => {
        const data = snapshot.val();
        if (data !== previousData) {
          previousData = data;

          if (data.guessedWordbyparticipant && data.guessedWordbyparticipant.length > 0) {
            const guessedWordsCount = data.guessedWordbyparticipant.reduce((acc, current) => {
              acc[current.guessedword] = (acc[current.guessedword] || 0) + 1;
              return acc;
            }, {});

            const totalGuessedWords = data.guessedWordbyparticipant.length;
            const calculatedGuessedWords = Object.keys(guessedWordsCount).map((word) => ({
              word,
              count: guessedWordsCount[word],
              percentage: (guessedWordsCount[word] / totalGuessedWords) * 100,
            }));

            setGuessedWords(calculatedGuessedWords);
          } else {
            setGuessedWords([]);
          }

          if (data.scores) {
            const participantName = fullname;
            if (data.scores[participantName]) {
              setCurrentScore(data.scores[participantName].score);
            }
          }

          if (data.participantsStartedAnswering) {
            setParticipantsStartedAnswering(true);
          }

          const currentTeamName = data.currentteam || null;
          const guessedNames = data.guessedWordbyparticipant
            ? data.guessedWordbyparticipant.map((item) => item.name)
            : [];

          const teamParticipants =
            data.teamNames && currentTeamName
              ? data.teamNames
                .filter((team) => team.allocatedTeam === currentTeamName)
                .filter((team) => !guessedNames.includes(team.name))
                .map((team) => ({
                  initials: team.initials,
                  name: team.name,
                  profileColor: team.profileColor,
                  allocatedTeam: team.allocatedTeam,
                }))
              : [];

          setParticipants(teamParticipants);
        }
      });
    }
  }, [code, participantsStartedAnswering]);




  useEffect(() => {
    console.log("participantsStartedAnswering:", participantsStartedAnswering);
  }, [participantsStartedAnswering]);

  const showNextTurnModalWithTeam = (teamName) => {
    setNextTeamName(teamName);
    setShowNextTurnModal(true);
  };

  // final score
  // const calculateScore = (guessedWordByParticipant, guessedWord) => {
  //   console.log(
  //     "calculateScore called with:",
  //     guessedWordByParticipant,
  //     guessedWord
  //   );

  //   const db = firebase.database();
  //   const ref = db.ref(`AppleTV/${code}`);

  //   // Retrieve the current scores of all participants from Firebase
  //   ref.child("scores").once("value", (snapshot) => {
  //     if (guessedWordByParticipant && Array.isArray(guessedWordByParticipant)) {
  //       // The correct guessed word
  //       const correctWord = Object.keys(guessedWord)[0]; // Assuming guessedWord structure is like { "A": "right" }

  //       // Loop through all participants who have guessed a word
  //       guessedWordByParticipant.forEach((participantData) => {
  //         console.log("Processing guessedWordData:", participantData);

  //         const participantName = participantData.name; // Get participant's name
  //         const guessedWordResult = guessedWord[correctWord]; // Get the result for the guessed letter

  //         // Only grant score if the guessed word is correct and matches the guessed word
  //         if (
  //           guessedWordResult === "right" &&
  //           participantData.guessedword === correctWord
  //         ) {
  //           const prevScore = snapshot.val()?.[participantName]?.score ?? 0; // Maintain previous score
  //           const newScore = prevScore + 100; // Update score by 100 for a correct guess

  //           console.log(
  //             `New score for ${participantName} (correct):`,
  //             newScore
  //           );
  //           setCurrentScore(newScore); // Update current score in the state
  //           updateScoreInDatabase(participantName, 100, true); // Update score in Firebase
  //         }
  //         // If guessed word is wrong or does not match the correct guess
  //         else {
  //           const prevScore = snapshot.val()?.[participantName]?.score ?? 0; // Maintain previous score
  //           console.log(
  //             `Score remains the same for ${participantName} (wrong guess):`,
  //             prevScore
  //           );
  //           setCurrentScore(prevScore); // Maintain previous score
  //           updateScoreInDatabase(participantName, 0, false); 
  //         }
  //       });
  //     } else {
  //       console.warn("guessedWordByParticipant is undefined or not an array");
  //     }
  //   });
  // };
  // const calculateScore = (guessedWordByParticipant, guessedWord) => {
  //   const fullPath = window.location.pathname;
  //   const isCLParamPresent = fullPath.includes("m=cl");
  //   console.log("Is m=cl present:", isCLParamPresent);

  //   const db = firebase.database();
  //   const ref = db.ref(`AppleTV/${code}`);

  //   // Retrieve current scores
  //   ref.child("scores").once("value", (snapshot) => {
  //     if (guessedWordByParticipant && Array.isArray(guessedWordByParticipant)) {
  //       const correctWord = Object.keys(guessedWord)[0]; // Correct guessed word

  //       guessedWordByParticipant.forEach((participantData) => {
  //         console.log("Processing guessedWordData:", participantData);

  //         const participantName = participantData.name; // Participant's name
  //         const guessedWordResult = guessedWord[correctWord]; // Correctness of the guessed letter

  //         if (
  //           guessedWordResult === "right" &&
  //           participantData.guessedword === correctWord
  //         ) {
  //           console.log(`Correct guess by ${participantName}! Updating...`);

  //           // Update score by 100 and correct answers by 1
  //           updateScoreInDatabase(participantName, 100, 1, true);
  //         } else {
  //           console.log(`Wrong guess by ${participantName}. No update.`);

  //           // No changes for incorrect guesses
  //           updateScoreInDatabase(participantName, 0, 0, false);
  //         }
  //       });
  //     } else {
  //       console.warn("guessedWordByParticipant is undefined or not an array");
  //     }
  //   });
  // };

  // final
  // const updateScoreInDatabase = (participantName, score, animate) => {
  //   const db = firebase.database();
  //   const ref = db.ref(`AppleTV/${code}`);

  //   // Update the score in the database for the participant
  // ref
  //   .child("scores")
  //   .child(participantName)
  //   .transaction((currentData) => {
  //     // If no previous data, initialize it
  //     if (currentData === null) {
  //       return { name: participantName, score: score, animate: animate }; 
  //     }
  //     // Update existing score
  //     currentData.score += score; // Increment the score
  //     currentData.animate = animate; 
  //     return currentData; // Return updated data
  //   })
  //     .then(() => {
  //       console.log(`Score updated successfully for ${participantName} in the database`);

  //       // Set a timeout to reset all animate flags after 2 seconds
  //       setTimeout(() => {
  //         // Update all participants to set animate to false
  //         ref.child("scores").once("value").then(snapshot => {
  //           snapshot.forEach(childSnapshot => {
  //             const childRef = childSnapshot.ref;
  //             childRef.transaction(currentData => {
  //               if (currentData) {
  //                 currentData.animate = false; // Set animate to false
  //               }
  //               return currentData; // Return updated data
  //             });
  //           });
  //         });

  //       }, 500); // 2000 milliseconds = 2 seconds

  //     })
  //     .catch((error) => {
  //       console.error("Error updating score in the database:", error);
  //     });
  // };

  // const updateScoreInDatabase = async (participantName, score, correctAnswers, animate) => {
  //   const db = firebase.database();
  //   const ref = db.ref(`AppleTV/${code}`);
  //   const apiUrl = `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`;
  //   const fullPath = window.location.pathname;
  //   const isCLParamPresent = fullPath.includes("m=cl");
  //   console.log("Is m=cl present:", isCLParamPresent);

  //   try {
  //     // Fetch current session data
  //     const response = await fetch(apiUrl);
  //     const data = await response.json();
  //     const sessionData = Array.isArray(data) ? data : [];
  //     const currentSession = sessionData[sessionData.length - 1];

  //     // Update Firebase score for the participant in AppleTV database
  //     await ref.child("scores").child(participantName).transaction((currentData) => {
  //       if (currentData === null) {
  //         return { name: participantName, score, correctanswer: correctAnswers, animate };
  //       }
  //       // Instead of incrementing, we set the score and correct answers directly from local storage
  //       return {
  //         name: participantName,
  //         score: (currentData.score || 0) + score, // Increment the score
  //         correctanswer: (currentData.correctanswer || 0) + correctAnswers, // Increment correct answers
  //         animate: animate,
  //       };
  //     });

  //     console.log(`Score and correctanswers updated successfully for ${participantName} in the database`);

  //     // Retrieve updated Firebase scores and save to localStorage
  //     const snapshot = await ref.child("scores").once("value");
  //     const scores = [];
  //     snapshot.forEach((childSnapshot) => {
  //       const data = childSnapshot.val();
  //       scores.push(data);
  //     });

  //     // Save updated scores to localStorage
  //     localStorage.setItem("scores", JSON.stringify(scores));
  //     console.log("Scores saved to localStorage:", scores);

  //     // Retrieve scores from localStorage
  //     const localScores = JSON.parse(localStorage.getItem("scores")) || [];

  //     if (isCLParamPresent) {
  //       if (currentSession) {
  //         if (!Array.isArray(currentSession.scores)) {
  //           currentSession.scores = [];
  //         }

  //         // Create a map for quick lookup of existing scores
  //         const existingScoresMap = new Map(currentSession.scores.map(score => [score.name, score]));

  //         // Merge localScores with current session scores from the database
  //         localScores.forEach(localScore => {
  //           const connectedStudent = connectedstudents.find(student => student.includes(localScore.name));
  //           const nameToUse = connectedStudent ? connectedStudent.split("&")[0] : localScore.name;

  //           if (existingScoresMap.has(nameToUse)) {
  //             // Update existing score
  //             const existingScore = existingScoresMap.get(nameToUse);
  //             existingScore.score = localScore.score; // Set the score directly from local storage
  //             existingScore.correctanswer = localScore.correctanswer; // Set correct answers directly
  //             existingScore.animate = localScore.animate; // Update animation state
  //           } else {
  //             // Add new participant
  //             existingScoresMap.set(nameToUse, {
  //               ...localScore,
  //               name: nameToUse,
  //             });
  //           }
  //         });

  //         // Convert the map back to an array
  //         const mergedScores = Array.from(existingScoresMap.values());

  //         // Update session data on the server with merged scores
  //         await fetch(apiUrl, {
  //           method: "PATCH",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({
  //             [`${sessionData.length - 1}`]: {
  //               ...currentSession,
  //               scores: mergedScores,
  //             },
  //           }),
  //         });

  //         console.log("Scores merged and updated in the session successfully.");
  //       } else {
  //         console.error("Current session not found.");
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error handling scores and session data:", error);
  //   }
  // };




  // final after classroom data updated in classroom and classroomleaderboard table
  const calculateScore = (guessedWordByParticipant, guessedWord) => {
    const fullPath = window.location.pathname;
    const isCLParamPresent = fullPath.includes("m=cl");
    console.log("Is m=cl present:", isCLParamPresent);

    const db = firebase.database();
    const ref = db.ref(`AppleTV/${code}`);

    // Retrieve current scores
    ref.child("scores").once("value", (snapshot) => {
      if (guessedWordByParticipant && Array.isArray(guessedWordByParticipant)) {
        const correctWord = Object.keys(guessedWord)[0]; // Correct guessed word

        guessedWordByParticipant.forEach((participantData) => {
          console.log("Processing guessedWordData:", participantData);

          const participantName = participantData.name; // Participant's name
          const guessedWordResult = guessedWord[correctWord]; // Correctness of the guessed letter

          if (
            guessedWordResult === "right" &&
            participantData.guessedword === correctWord
          ) {
            console.log(`Correct guess by ${participantName}! Updating...`);
            // Only update score for the correct participant
            updateScoreInDatabase(participantName, 100, 1, true);
          } else {
            console.log(`Wrong guess by ${participantName}. No update.`);
            // No changes for incorrect guesses
            updateScoreInDatabase(participantName, 0, 0, false);
          }
        });
      } else {
        console.warn("guessedWordByParticipant is undefined or not an array");
      }
    });
  };


  // final after classroom data updated in classroom and classroomleaderboard table

  const updateScoreInDatabase = async (participantName, score, correctAnswers, animate) => {
    const db = firebase.database();
    const ref = db.ref(`AppleTV/${code}`);
    const apiUrl = `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`;
    const fullPath = window.location.pathname;
    const isCLParamPresent = fullPath.includes("m=cl");
    const isCRParamPresent = fullPath.includes("m=cr");
    console.log("Is m=cl present:", isCLParamPresent);

    try {
      // Fetch current session data
      const response = await fetch(apiUrl);
      const data = await response.json();
      const sessionData = Array.isArray(data) ? data : [];
      const currentSession = sessionData[sessionData.length - 1];

      // Update Firebase score for the participant in AppleTV database
      await ref.child("scores").child(participantName).transaction((currentData) => {
        if (currentData === null) {
          return { name: participantName, score, correctanswer: correctAnswers, animate };
        }
        // Instead of incrementing, we set the score and correct answers directly from local storage
        return {
          name: participantName,
          score: (currentData.score || 0) + score, // Increment the score
          correctanswer: (currentData.correctanswer || 0) + correctAnswers, // Increment correct answers
          animate: animate,
        };
      });

      console.log(`Score and correctanswers updated successfully for ${participantName} in the database`);

      // Retrieve updated Firebase scores and save to localStorage
      const snapshot = await ref.child("scores").once("value");
      const scores = [];
      snapshot.forEach((childSnapshot) => {
        const data = childSnapshot.val();
        scores.push(data);
      });

      // Save updated scores to localStorage
      localStorage.setItem("scores", JSON.stringify(scores));
      console.log("Scores saved to localStorage:", scores);

      // Retrieve scores from localStorage
      const localScores = JSON.parse(localStorage.getItem("scores")) || [];

      if (isCLParamPresent) {
        if (currentSession) {
          if (!Array.isArray(currentSession.scores)) {
            currentSession.scores = [];
          }

          // Create a map for quick lookup of existing scores
          const existingScoresMap = new Map(currentSession.scores.map(score => [score.name, score]));

          // Merge localScores with current session scores from the database
          localScores.forEach(localScore => {
            const connectedStudent = connectedstudents.find(student => student.includes(localScore.name));
            const nameToUse = connectedStudent ? connectedStudent.split("&")[0] : localScore.name;

            if (existingScoresMap.has(nameToUse)) {
              // Update existing score
              const existingScore = existingScoresMap.get(nameToUse);
              existingScore.score = localScore.score; // Set the score directly from local storage
              existingScore.correctanswer = localScore.correctanswer; // Set correct answers directly
              existingScore.animate = localScore.animate; // Update animation state
            } else {
              // Add new participant
              existingScoresMap.set(nameToUse, {
                ...localScore,
                name: nameToUse,
              });
            }
          });

          // Convert the map back to an array
          const mergedScores = Array.from(existingScoresMap.values());

          // Update session data on the server with merged scores
          await fetch(apiUrl, {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              [`${sessionData.length - 1}`]: {
                ...currentSession,
                scores: mergedScores,
              },
            }),
          });

          console.log("Scores merged and updated in the session successfully.");
        } else {
          console.error("Current session not found.");
        }
      }

      if (isCRParamPresent) {
        try {
          // Update crowd array in Firebase
          await ref.child("crowd").transaction((crowdData) => {
            // Ensure crowdData exists and has a 'scores' array
            if (!crowdData) {
              crowdData = {};  // Initialize as empty object if crowdData is undefined
            }

            // If 'scores' is not an array, initialize it as an empty array
            if (!Array.isArray(crowdData[0].scores)) {
              crowdData[0].scores = [];
            }

            // Log the current structure of crowdData to verify it
            console.log('Current crowdData:', crowdData);

            // Set the score for the first entry in the scores array (if it exists)
            if (crowdData[0].scores.length > 0) {
              const firstScore = crowdData[0].scores[0]; // Access the first item
              firstScore.score = localScores[0] ? localScores[0].score : 0; // Set first score value (adjust as needed)
            }

            // Create a map for quick lookup of existing scores from the crowdData.scores array
            const existingScoresMap = new Map(crowdData[0].scores.map(score => [score.name, score]));

            // Merge localScores with the current scores data
            localScores.forEach(localScore => {
              const connectedStudent = crowdData[0].scores.find(student => student.name.includes(localScore.name));

              if (connectedStudent) {
                // If a matching student is found, update their score and other properties
                connectedStudent.score = localScore.score; // Set score from localScore
                connectedStudent.correctanswer = localScore.correctanswer; // Set correct answer from localScore
                connectedStudent.animate = localScore.animate; // Set animate property if necessary
              } else {
                // If no matching student is found, you can choose to add the new score data
                crowdData[0].scores.push({
                  name: localScore.name,
                  score: localScore.score,
                  correctanswer: localScore.correctanswer,
                  animate: localScore.animate
                });
              }

            });

            // Return the modified crowdData object, ensuring the 'scores' array is correctly updated
            return crowdData;  // Make sure to return the updated object
          });

          console.log("Crowd data updated with merged scores successfully.");
        } catch (error) {
          console.error("Error updating crowd data:", error);
        }
      }



    } catch (error) {
      console.error("Error handling scores and session data:", error);
    }
  };



  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };
  useEffect(() => {
    // Preload the audio on component mount
    wrongLetterAudio.load();
    correctLetterAudio.load();
  }, []);

  const wrongLetterAudio = new Audio(WrongLetter);
  const correctLetterAudio = new Audio(CorrectLetter);

  // final of handleLetterClick
  // const handleLetterClick = async (letter) => {
  //   const fullPath = window.location.pathname;
  //   console.log("Full URL Path:", fullPath);

  //   const isCRParamPresent = fullPath.includes("m=cr");
  //   const isPlayMode = fullPath.includes("m=play");
  //   const isCLParamPresent = fullPath.includes("m=cl");
  //   console.log("Is m=cr present:", isCRParamPresent);
  //   console.log("Is m=cl present:", isCLParamPresent);
  //   console.log("Is m=play present:", isPlayMode);

  //   // Check if the letter has already been guessed or if max wrong guesses have been reached
  //   if (guessedLetters.includes(letter) || wrongGuesses >= hangmanImages.length - 1) {
  //       console.log("Letter already guessed or maximum wrong guesses reached.");
  //       return; // Exit early if the letter is already guessed or max wrong guesses reached
  //   }

  //   // Update guessed letters
  //   const updatedGuessedLetters = [...guessedLetters, letter];
  //   setGuessedLetters(updatedGuessedLetters); // Update guessedLetters state

  //   const currentTeamIndex = currentTeam;

  //   // Check if the guessed letter is in the word
  //   if (!wordToGuess.includes(letter)) {
  //       // Wrong guess, increase wrong guesses count and switch team
  //       setWrongGuesses((prevGuesses) => {
  //           const newGuesses = prevGuesses + 1;
  //           // Check for draw condition
  //           if (newGuesses >= hangmanImages.length - 1) {
  //               handleDrawCondition();
  //           }
  //           return newGuesses;
  //       });

  //       // If the URL contains 'm=play', the next team should always be 0 when a wrong guess occurs.
  //       const nextTeamIndex = isPlayMode ? 0 : currentTeamIndex === 0 ? 1 : 0;
  //       setCurrentTeam(nextTeamIndex); // Update the currentTeam state variable

  //       // Show the next turn modal only if m=cr is present
  //       if (isCRParamPresent || isCLParamPresent) {
  //           const nextTeamName = teamNames[nextTeamIndex];
  //           showNextTurnModalWithTeam(nextTeamName);
  //       }

  //       // Play incorrect guess sound
  //       wrongLetterAudio.play();

  //       // Update Firebase with the new team and guessed word
  //       await updateTeamInFirebase(nextTeamIndex);
  //       await updateGuessedWordInFirebase(letter, "wrong");
  //   } else {
  //       // Correct guess, check if all letters are guessed
  //       const allLettersGuessed = wordToGuess
  //       .split("")
  //       .filter((char) => /[a-zA-Z]/.test(char)) // Consider only alphabetical characters
  //       .every((char) => updatedGuessedLetters.includes(char));

  //       // Play correct guess sound
  //       correctLetterAudio.play();

  //       // Update Firebase with the same team (since no switch occurs) and guessed word
  //       await updateTeamInFirebase(currentTeamIndex);
  //       await updateGuessedWordInFirebase(letter, "right");

  //       // Show the next turn modal only if m=cr is present
  //       if (isCRParamPresent || isCLParamPresent) {
  //           const nextTeamName = currentTeamIndex === 0 ? teamNames[0] : teamNames[1];
  //           showNextTurnModalWithTeam(nextTeamName);
  //       }

  //       if (allLettersGuessed) {
  //           // Handle win case
  //           handleWin(currentTeamIndex);
  //       }
  //   }

  //   // Check if URL parameter m=cr exists
  //   if (isCRParamPresent || isCLParamPresent) {
  //       console.log("Condition met for m=cr, fetching guessedWordbyparticipant from Firebase...");
  //       const guessedWordbyparticipant = await getGuessedWordbyparticipantFromFirebase();
  //       console.log("Fetched guessedWordbyparticipant:", guessedWordbyparticipant);

  //       if (guessedWordbyparticipant) {
  //           await updateGuessedWordArrayInFirebase(updatedGuessedLetters);
  //           console.log("Updated guessedWord array in Firebase:", updatedGuessedLetters);

  //           calculateScore(guessedWordbyparticipant, {
  //               [letter]: wordToGuess.includes(letter) ? "right" : "wrong",
  //           });
  //           console.log("calculateScore function called");
  //       } else {
  //         setShowNextTurnModal(false);
  //         // setParticipantsStartedAnswering(true);
  //           console.log("No guessedWordbyparticipant data found.");
  //       }
  //   } else {
  //       console.log("Condition for m=cr not met.");
  //   }
  // };


  const handleLetterClick = async (letter) => {
    const fullPath = window.location.pathname;
    console.log("Full URL Path:", fullPath);

    const isCRParamPresent = fullPath.includes("m=cr");
    const isPlayMode = fullPath.includes("m=play");
    const isCLParamPresent = fullPath.includes("m=cl");
    console.log("Is m=cr present:", isCRParamPresent);
    console.log("Is m=cl present:", isCLParamPresent);
    console.log("Is m=play present:", isPlayMode);

    // Check if the letter has already been guessed or if max wrong guesses have been reached
    if (guessedLetters.includes(letter) || wrongGuesses >= hangmanImages.length - 1) {
      console.log("Letter already guessed or maximum wrong guesses reached.");
      return; // Exit early if the letter is already guessed or max wrong guesses reached
    }

    // Update guessed letters
    const updatedGuessedLetters = [...guessedLetters, letter];
    setGuessedLetters(updatedGuessedLetters); // Update guessedLetters state

    const currentTeamIndex = currentTeam;

    // Normalize the letter for comparison based on language
    const normalizedLetter = normalizeCharacter(letter, currentLanguage);
    const normalizedWord = currentLanguage === 'ar' ? wordToGuess : wordToGuess.toUpperCase();

    // Check if the guessed letter is in the word
    if (!normalizedWord.includes(normalizedLetter)) {
      // Wrong guess, increase wrong guesses count and switch team
      setWrongGuesses((prevGuesses) => {
        const newGuesses = prevGuesses + 1;
        // Check for draw condition
        if (newGuesses >= hangmanImages.length - 1) {
          handleDrawCondition();
        }
        return newGuesses;
      });

      // If the URL contains 'm=play', the next team should always be 0 when a wrong guess occurs.
      const nextTeamIndex = isPlayMode ? 0 : currentTeamIndex === 0 ? 1 : 0;
      setCurrentTeam(nextTeamIndex); // Update the currentTeam state variable

      // Show the next turn modal only if m=cr is present
      if (isCRParamPresent || isCLParamPresent) {
        const nextTeamName = teamNames?.[nextTeamIndex] || `Team ${nextTeamIndex + 1}`;
        showNextTurnModalWithTeam(nextTeamName);
      }

      // Play incorrect guess sound
      wrongLetterAudio.play();

      // Update Firebase with the new team and guessed word
      await updateTeamInFirebase(nextTeamIndex);
      await updateGuessedWordInFirebase(letter, "wrong");
    } else {
      // Correct guess, check if all letters are guessed
      const allLettersGuessed = normalizedWord
        .split("")
        .filter((char) => {
          // Filter based on language - Arabic or English characters
          if (currentLanguage === 'ar') {
            return /[\u0600-\u06FF]/.test(char); // Arabic Unicode range
          } else {
            return /[a-zA-Z]/.test(char); // English alphabetical characters
          }
        })
        .every((char) => {
          const normalizedChar = normalizeCharacter(char, currentLanguage);
          return updatedGuessedLetters.some(guessedLetter =>
            normalizeCharacter(guessedLetter, currentLanguage) === normalizedChar
          );
        });

      // Play correct guess sound
      correctLetterAudio.play();

      // Update Firebase with the same team (since no switch occurs) and guessed word
      await updateTeamInFirebase(currentTeamIndex);
      await updateGuessedWordInFirebase(letter, "right");

      // Show the next turn modal only if m=cr is present
      if (isCRParamPresent || isCLParamPresent) {
        const nextTeamName = currentTeamIndex === 0 ? (teamNames?.[0] || "Team 1") : (teamNames?.[1] || "Team 2");
        showNextTurnModalWithTeam(nextTeamName);
      }

      if (allLettersGuessed) {
        // Handle win case
        handleWin(currentTeamIndex);
      }
    }

    // Check if URL parameter m=cr exists
    if (isCRParamPresent || isCLParamPresent) {
      console.log("Condition met for m=cr, fetching guessedWordbyparticipant from Firebase...");
      const guessedWordbyparticipant = await getGuessedWordbyparticipantFromFirebase();
      console.log("Fetched guessedWordbyparticipant:", guessedWordbyparticipant);

      if (guessedWordbyparticipant) {
        await updateGuessedWordArrayInFirebase(updatedGuessedLetters);
        console.log("Updated guessedWord array in Firebase:", updatedGuessedLetters);

        calculateScore(guessedWordbyparticipant, {
          [letter]: wordToGuess.includes(letter) ? "right" : "wrong",
        });
        console.log("calculateScore function called");
        storeGuessedWordDataInLocalStorageFromFirebase(guessedWordbyparticipant);
      } else {
        setShowNextTurnModal(false);
        // setParticipantsStartedAnswering(true);
        console.log("No guessedWordbyparticipant data found.");
      }
    } else {
      console.log("Condition for m=cr not met.");
    }
  };


  const storeGuessedWordDataInLocalStorageFromFirebase = (guessedWordbyparticipant) => {
    // Fetch existing data from localStorage, or initialize an empty object if none exists
    const existingData = JSON.parse(localStorage.getItem("guessedWordData by participnat")) || {};

    // Iterate over each participant and their guessed word
    guessedWordbyparticipant.forEach(({ name, guessedword }) => {
      // Check if name and guessedword are valid
      if (name && guessedword) {
        // Check if the name already exists in the localStorage object
        if (existingData[name]) {
          // If the guessed word is not already added, append it
          if (!existingData[name].includes(guessedword)) {
            existingData[name] += `,${guessedword}`; // Append new guessed word
          }
        } else {
          // If the name doesn't exist, add the guessed word
          existingData[name] = guessedword;
        }
      }
    });

    // Save the updated data back to localStorage
    localStorage.setItem("guessedWordData by participnat", JSON.stringify(existingData));

    console.log("Updated localStorage with fetched data:", existingData);
  };

  // final
  // const handleWin = async (teamIndex) => {
  //   try {
  //     // Update the score for the winning team
  //     setScore((prevScore) => {
  //       const updatedScore = [...prevScore];
  //       updatedScore[teamIndex] += 1; // Increment score for the current team
  //       return updatedScore;
  //     });

  //     setWinningTeam(teamIndex);
  //     setShowNextTurnModal(false);
  //     setParticipantsStartedAnswering(false);
  //     setShowWinModal(true);

  //     const roundIndex = rounds.findIndex(
  //       (round) =>
  //         round.answer.trim().toLowerCase() === wordToGuess.trim().toLowerCase()
  //     );
  //     const roundWinners = JSON.parse(localStorage.getItem("roundWinners")) || [];



  //     if (
  //       !roundWinners.some(
  //         (winner) =>
  //           winner.round === roundIndex + 1 &&
  //           winner.team === teamNames[teamIndex]
  //       )
  //     ) {
  //       roundWinners.push({
  //         round: roundIndex + 1,
  //         team: teamNames[teamIndex],
  //       });
  //       localStorage.setItem("roundWinners", JSON.stringify(roundWinners));
  //     }


  //   } catch (error) {
  //     console.error("Error in handleWin:", error);
  //   }

  //   localStorage.removeItem("guessedWordData by participnat");
  // };

  // const handleWin = async (teamIndex) => {
  //   try {
  //     // Update the score for the winning team
  //     setScore((prevScore) => {
  //       const updatedScore = [...prevScore];
  //       updatedScore[teamIndex] += 1; // Increment score for the current team
  //       return updatedScore;
  //     });

  //     setWinningTeam(teamIndex);
  //     setShowNextTurnModal(false);
  //     setParticipantsStartedAnswering(false);
  //     setShowWinModal(true);

  //     const roundIndex = rounds.findIndex(
  //       (round) =>
  //         round.answer.trim().toLowerCase() === wordToGuess.trim().toLowerCase()
  //     );
  //     const roundWinners = JSON.parse(localStorage.getItem("roundWinners")) || [];
  //     const fullPath = window.location.pathname;
  //     const isCLParamPresent = fullPath.includes("m=cl");

  //     if (isCLParamPresent) {
  //       const selectedRound = JSON.parse(localStorage.getItem("selectedRound"));
  //       if (!selectedRound || !selectedRound.question || !selectedRound.answer) {
  //         console.error("SelectedRound is missing required fields.");
  //         return;
  //       }

  //       const question = selectedRound.question;
  //       const correctAnswer = selectedRound.answer;

  //       const db = firebase.database();
  //       const ref = db.ref(`AppleTV/${code}/teamNames`);

  //       const apiUrl = `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`;
  //       const classroomUrl = `https://trivia-maker.firebaseio.com/Classroom/${clid}.json`;

  //       const [currentDataResponse, teamNamesSnapshot] = await Promise.all([
  //         axios.get(classroomUrl),
  //         ref.once("value"),
  //       ]);

  //       const currentDataForClassroom = currentDataResponse.data;
  //       const teamNamesData = teamNamesSnapshot.val();

  //       if (!teamNamesData || !Array.isArray(teamNamesData)) {
  //         console.error("Invalid team names data.");
  //         return;
  //       }

  //       const sessionResponse = await fetch(apiUrl);
  //       const sessionData = await sessionResponse.json();

  //       const currentSession = Array.isArray(sessionData)
  //         ? sessionData[sessionData.length - 1]
  //         : null;

  //       if (!currentSession) {
  //         console.error("Current session not found.");
  //         return;
  //       }

  //       const guessedWordData = JSON.parse(
  //         localStorage.getItem("guessedWordData by participnat")
  //       ) || {};


  //       if (currentSession.connectedstudents) {
  //         const extractedStudents = currentSession.connectedstudents.map((student) =>
  //           student.split("&")[0]
  //         );
  //         setconnectedStudent(extractedStudents);

  //         if (currentDataForClassroom && currentDataForClassroom.students) {
  //           currentDataForClassroom.students.forEach((student) => {
  //             if (extractedStudents.includes(student.stuname)) {
  //               student.questionattempted = (student.questionattempted || 0) + 1;
  //             }
  //           });

  //           try {
  //             await fetch(classroomUrl, {
  //               method: "PATCH",
  //               headers: {
  //                 "Content-Type": "application/json",
  //               },
  //               body: JSON.stringify({
  //                 students: currentDataForClassroom.students,
  //               }),
  //             });
  //           } catch (error) {
  //             console.error("Error patching updated student data:", error);
  //           }
  //         }
  //       }

  //       const revealCharactersObject = {};
  //       Object.keys(guessedWordData).forEach((name) => {
  //         const teamInfo = teamNamesData.find((team) => team.name === name);
  //         if (teamInfo) {
  //           const key = `${teamInfo.initials}+${teamInfo.profileColor}+-+${teamInfo.name.replace(
  //             /\s+/g,
  //             "+"
  //           )}`;
  //           const guessedCharacters = guessedWordData[name]
  //             .split(",")
  //             .map((char) => char.trim())
  //             .join(",");
  //           revealCharactersObject[key] = { revealedcharacters: guessedCharacters };
  //         }
  //       });

  //       const questionsarray = Array.isArray(currentSession.questionsarray)
  //         ? [...currentSession.questionsarray]
  //         : [];
  //       questionsarray.push({ correctanswer: correctAnswer, question });

  //       const participantsanwers = Array.isArray(currentSession.participantsanwers)
  //         ? [...currentSession.participantsanwers]
  //         : [];
  //       participantsanwers.push(revealCharactersObject);

  //       const updatedSession = {
  //         ...currentSession,
  //         questionsarray,
  //         participantsanwers,
  //       };

  //       try {
  //         await fetch(apiUrl, {
  //           method: "PATCH",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({
  //             [`${sessionData.length - 1}`]: updatedSession,
  //           }),
  //         });

  //         console.log("Question and answer added to the current session.");
  //         localStorage.removeItem("guessedWordData by participnat");
  //       } catch (error) {
  //         console.error("Error updating the session:", error);
  //       }
  //     }

  //     if (
  //       !roundWinners.some(
  //         (winner) =>
  //           winner.round === roundIndex + 1 &&
  //           winner.team === teamNames[teamIndex]
  //       )
  //     ) {
  //       roundWinners.push({
  //         round: roundIndex + 1,
  //         team: teamNames[teamIndex],
  //       });
  //       localStorage.setItem("roundWinners", JSON.stringify(roundWinners));
  //     }
  //   } catch (error) {
  //     console.error("Error in handleWin:", error);
  //   }
  // };


  // // Function to handle draw condition

  // const handleDrawCondition = async () => {
  //   console.log("handleDrawCondition invoked");
  //   setIsDraw(true); // Set draw state to true to reveal the word
  //   setShowNextTurnModal(false);
  //   setParticipantsStartedAnswering(false);
  //   setShowDrawModal(true); // Show draw modal

  //   // Find the current round index by matching the answer with wordToGuess
  //   const roundIndex = rounds.findIndex(
  //     (round) =>
  //       round.answer.trim().toLowerCase() === wordToGuess.trim().toLowerCase()
  //   );

  //   const roundWinners = JSON.parse(localStorage.getItem("roundWinners")) || [];

  //   // Check if the draw already exists in the round winners array
  //   const alreadyExists = roundWinners.some(
  //     (winner) => winner.round === roundIndex + 1 && winner.team === "Draw"
  //   );

  //   // If it doesn't exist, add the draw result for this round
  //   if (!alreadyExists) {
  //     roundWinners.push({
  //       round: roundIndex + 1,
  //       team: "Draw", // Mark this round as a draw
  //     });

  //     localStorage.setItem("roundWinners", JSON.stringify(roundWinners));

  //     const selectedRound = JSON.parse(localStorage.getItem("selectedRound")); // Assuming selectedRound is stored in localStorage
  //     const question = selectedRound?.question;
  //     const correctAnswer = selectedRound?.answer;

  //     if (question && correctAnswer) {
  //       const apiUrl = `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`;

  //       try {
  //         // Fetch the current session data
  //         const response = await fetch(apiUrl);
  //         const data = await response.json(); // Parse the JSON response

  //         // Check if data is an array and get the last session
  //         const sessionData = Array.isArray(data) ? data : [];
  //         const currentSession = sessionData[sessionData.length - 1];

  //         if (currentSession) {
  //           // Check if `questionsarray` exists; if not, initialize it
  //           const questionsarray = Array.isArray(currentSession.questionsarray)
  //             ? currentSession.questionsarray
  //             : [];

  //           // Append the new question and answer
  //           questionsarray.push({
  //             correctanswer: correctAnswer,
  //             question: question,
  //           });

  //           // Update the database with the modified session
  //           await fetch(apiUrl, {
  //             method: "PATCH", // Use PATCH to update specific fields
  //             headers: {
  //               "Content-Type": "application/json",
  //             },
  //             body: JSON.stringify({
  //               [`${sessionData.length - 1}`]: {
  //                 ...currentSession,
  //                 questionsarray: questionsarray,
  //               },
  //             }),
  //           });

  //           console.log("Question and answer added to the current session.");
  //         } else {
  //           console.error("Current session not found.");
  //         }
  //       } catch (error) {
  //         console.error("Error updating the current session:", error);
  //       }
  //     } else {
  //       console.error("SelectedRound is missing required fields.");
  //     }
  //   }
  // };
  // final


  // const handleDrawCondition = async () => {
  //   console.log("handleDrawCondition invoked");

  //   // Set state to show draw modal and prepare for the next round
  //   setIsDraw(true);
  //   setShowNextTurnModal(false);
  //   setParticipantsStartedAnswering(false);
  //   setShowDrawModal(true);

  //   try {

  //     const fullPath = window.location.pathname;
  //     const isCLParamPresent = fullPath.includes("m=cl");
  //     console.log("Is m=cl param present:", isCLParamPresent);

  //     if (isCLParamPresent) {
  //       // Retrieve selected round details from localStorage
  //       const selectedRound = JSON.parse(localStorage.getItem("selectedRound"));
  //       if (!selectedRound || !selectedRound.question || !selectedRound.answer) {
  //         console.error("SelectedRound is missing required fields.");
  //         return;
  //       }

  //       const { question, answer: correctAnswer } = selectedRound;

  //       // Initialize Firebase database reference
  //       const db = firebase.database();
  //       const ref = db.ref(`AppleTV/${code}/teamNames`);

  //       // Define API URLs for ClassroomLeaderboard and Classroom data
  //       const apiUrl = `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`;
  //       const classroomUrl = `https://trivia-maker.firebaseio.com/Classroom/${clid}.json`;

  //       // Fetch current classroom data and team names
  //       const [currentDataResponse, teamNamesSnapshot] = await Promise.all([
  //         axios.get(classroomUrl),
  //         ref.once("value"),
  //       ]);

  //       const currentDataForClassroom = currentDataResponse.data;
  //       const teamNamesData = teamNamesSnapshot.val();

  //       if (!teamNamesData || !Array.isArray(teamNamesData)) {
  //         console.error("Invalid team names data.");
  //         return;
  //       }

  //       // Fetch the current ClassroomLeaderboard session
  //       const sessionResponse = await fetch(apiUrl);
  //       const sessionData = await sessionResponse.json();

  //       const currentSession = Array.isArray(sessionData)
  //         ? sessionData[sessionData.length - 1]
  //         : null;

  //       if (!currentSession) {
  //         console.error("Current session not found.");
  //         return;
  //       }

  //       // Retrieve guessed word data from localStorage
  //       const guessedWordData = JSON.parse(localStorage.getItem("guessedWordData by participnat")) || {};

  //       // Extract connected students from current session
  //       if (currentSession.connectedstudents) {
  //         const extractedStudents = currentSession.connectedstudents.map((student) =>
  //           student.split("&")[0]
  //         );
  //         setconnectedStudent(extractedStudents);
  //         console.log("Connected students:", extractedStudents);

  //         if (currentDataForClassroom && currentDataForClassroom.students) {
  //           // Update students' question attempts in the classroom data
  //           currentDataForClassroom.students.forEach((student) => {
  //             if (extractedStudents.includes(student.stuname)) {
  //               student.questionattempted = (student.questionattempted || 0) + 1;
  //             }
  //           });

  //           console.log("Updated students:", currentDataForClassroom.students);

  //           // Patch the updated student data to the Classroom database
  //           try {
  //             await fetch(classroomUrl, {
  //               method: "PATCH",
  //               headers: {
  //                 "Content-Type": "application/json",
  //               },
  //               body: JSON.stringify({
  //                 students: currentDataForClassroom.students,
  //               }),
  //             });

  //             console.log("Updated student data successfully patched to Classroom.");
  //           } catch (error) {
  //             console.error("Error patching updated student data:", error);
  //           }
  //         }
  //       }

  //       // Create reveal characters object for each team
  //       const revealCharactersObject = {};
  //       Object.keys(guessedWordData).forEach(( name) => {
  //         const teamInfo = teamNamesData.find((team) => team.name === name);
  //         if (teamInfo) {
  //           const key = `${teamInfo.initials}+${teamInfo.profileColor}+-+${teamInfo.name.replace(
  //             /\s+/g,
  //             "+"
  //           )}`;
  //           const guessedCharacters = guessedWordData[name]
  //             .split(",")
  //             .map((char) => char.trim())
  //             .join(",");
  //           revealCharactersObject[key] = { revealedcharacters: guessedCharacters };
  //         }
  //       });

  //       // Prepare the updated session data with the new answers
  //       const questionsarray = currentSession.questionsarray || [];
  //       const participantsanwers = currentSession.participantsanwers || [];
  //       questionsarray.push({ correctanswer: correctAnswer, question });
  //       participantsanwers.push(revealCharactersObject);

  //       const updatedSessionData = {
  //         ...currentSession,
  //         questionsarray,
  //         participantsanwers,
  //       };

  //       console.log("Final session data to patch:", updatedSessionData);

  //       // Send updated session data to the ClassroomLeaderboard API
  //       const patchResponse = await fetch(apiUrl, {
  //         method: "PATCH",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           [`${sessionData.length - 1}`]: updatedSessionData,
  //         }),
  //       });

  //       if (!patchResponse.ok) {
  //         console.error("Failed to update session data:", patchResponse.statusText);
  //       } else {
  //         console.log("Question and answer added to the current session.");
  //       }

  //       // Remove guessed word data from localStorage
  //       localStorage.removeItem("guessedWordData by participnat");
  //     }
  //     // Find the current round index by comparing the word to guess
  //     const roundIndex = rounds.findIndex(
  //       (round) =>
  //         round.answer.trim().toLowerCase() === wordToGuess.trim().toLowerCase()
  //     );

  //     console.log("Current round index:", roundIndex);



  //     // Get round winners from localStorage
  //     const roundWinners = JSON.parse(localStorage.getItem("roundWinners")) || [];

  //     // Check if the draw already exists in the round winners array
  //     const alreadyExists = roundWinners.some(
  //       (winner) => winner.round === roundIndex + 1 && winner.team === "Draw"
  //     );

  //     if (!alreadyExists) {
  //       roundWinners.push({
  //         round: roundIndex + 1,
  //         team: "Draw",
  //       });
  //       localStorage.setItem("roundWinners", JSON.stringify(roundWinners));
  //     }

  //   } catch (error) {
  //     console.error("Error in handleDrawCondition:", error);
  //     alert("Error occurred while processing the draw condition: " + error.message);
  //   }
  // };

  const handleWin = async (teamIndex) => {
    try {
      // Update the score for the winning team
      setScore((prevScore) => {
        const updatedScore = [...prevScore];
        updatedScore[teamIndex] += 1; // Increment score for the current team
        return updatedScore;
      });

      setWinningTeam(teamIndex);
      setShowNextTurnModal(false);
      setParticipantsStartedAnswering(false);
      setShowWinModal(true);

      const roundIndex = rounds.findIndex(
        (round) =>
          round.answer.trim().toLowerCase() === wordToGuess.trim().toLowerCase()
      );
      const roundWinners = JSON.parse(localStorage.getItem("roundWinners")) || [];
      const fullPath = window.location.pathname;
      const isCLParamPresent = fullPath.includes("m=cl");
      const isCRParamPresent = fullPath.includes("m=cr");

      if (isCLParamPresent) {
        const selectedRound = JSON.parse(localStorage.getItem("selectedRound"));
        if (!selectedRound || !selectedRound.question || !selectedRound.answer) {
          console.error("SelectedRound is missing required fields.");
          return;
        }

        const question = selectedRound.question;
        const correctAnswer = selectedRound.answer;

        const db = firebase.database();
        const ref = db.ref(`AppleTV/${code}/teamNames`);

        const apiUrl = `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`;
        const classroomUrl = `https://trivia-maker.firebaseio.com/Classroom/${clid}.json`;

        const [currentDataResponse, teamNamesSnapshot] = await Promise.all([
          axios.get(classroomUrl),
          ref.once("value"),
        ]);

        const currentDataForClassroom = currentDataResponse.data;
        const teamNamesData = teamNamesSnapshot.val();

        if (!teamNamesData || !Array.isArray(teamNamesData)) {
          console.error("Invalid team names data.");
          return;
        }

        const sessionResponse = await fetch(apiUrl);
        const sessionData = await sessionResponse.json();

        const currentSession = Array.isArray(sessionData)
          ? sessionData[sessionData.length - 1]
          : null;

        if (!currentSession) {
          console.error("Current session not found.");
          return;
        }

        const guessedWordData = JSON.parse(
          localStorage.getItem("guessedWordData by participnat")
        ) || {};


        if (currentSession.connectedstudents) {
          const extractedStudents = currentSession.connectedstudents.map((student) =>
            student.split("&")[0]
          );
          setconnectedStudent(extractedStudents);

          if (currentDataForClassroom && currentDataForClassroom.students) {
            currentDataForClassroom.students.forEach((student) => {
              if (extractedStudents.includes(student.stuname)) {
                student.questionattempted = (student.questionattempted || 0) + 1;
              }
            });

            try {
              await fetch(classroomUrl, {
                method: "PATCH",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  students: currentDataForClassroom.students,
                }),
              });
            } catch (error) {
              console.error("Error patching updated student data:", error);
            }
          }
        }

        const revealCharactersObject = {};
        Object.keys(guessedWordData).forEach((name) => {
          const teamInfo = teamNamesData.find((team) => team.name === name);
          if (teamInfo) {
            const key = `${teamInfo.initials}+${teamInfo.profileColor}+-+${teamInfo.name.replace(
              /\s+/g,
              "+"
            )}`;
            const guessedCharacters = guessedWordData[name]
              .split(",")
              .map((char) => char.trim())
              .join(",");
            revealCharactersObject[key] = { revealedcharacters: guessedCharacters };
          }
        });

        const questionsarray = Array.isArray(currentSession.questionsarray)
          ? [...currentSession.questionsarray]
          : [];
        questionsarray.push({ correctanswer: correctAnswer, question });

        const participantsanwers = Array.isArray(currentSession.participantsanwers)
          ? [...currentSession.participantsanwers]
          : [];
        participantsanwers.push(revealCharactersObject);

        const updatedSession = {
          ...currentSession,
          questionsarray,
          participantsanwers,
        };

        try {
          await fetch(apiUrl, {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              [`${sessionData.length - 1}`]: updatedSession,
            }),
          });

          console.log("Question and answer added to the current session.");
          localStorage.removeItem("guessedWordData by participnat");
        } catch (error) {
          console.error("Error updating the session:", error);
        }
      }

      if (isCRParamPresent) {
        // Retrieve selected round details from localStorage
        const selectedRound = JSON.parse(localStorage.getItem("selectedRound"));
        if (!selectedRound || !selectedRound.question || !selectedRound.answer) {
          console.error("SelectedRound is missing required fields.");
          return;
        }

        const { question, answer: correctAnswer } = selectedRound;

        // Initialize Firebase database reference
        const db = firebase.database();
        const teamNamesRef = db.ref(`AppleTV/${code}/teamNames`);
        const crowdRef = db.ref(`AppleTV/${code}/crowd`);

        try {
          // Fetch team names and crowd data
          const [teamNamesSnapshot, crowdSnapshot] = await Promise.all([
            teamNamesRef.once("value"),
            crowdRef.once("value"),
          ]);

          const teamNamesData = teamNamesSnapshot.val();
          const crowdData = crowdSnapshot.val();

          if (!teamNamesData || !Array.isArray(teamNamesData)) {
            console.error("Invalid team names data.");
            return;
          }

          console.log("Crowd data retrieved:", crowdData);

          // Retrieve guessed word data from localStorage
          const guessedWordData =
            JSON.parse(localStorage.getItem("guessedWordData by participnat")) || {};

          // Extract connected students from crowd data
          if (crowdData[0] && crowdData[0].connectedstudents) {
            const extractedStudents = crowdData[0].connectedstudents.map((student) =>
              student.split("&")[0]
            );
            setconnectedStudent(extractedStudents);
            console.log("Connected students:", extractedStudents);
          }

          // Create reveal characters object for each team
          const revealCharactersObject = {};
          Object.keys(guessedWordData).forEach((name) => {
            const teamInfo = teamNamesData.find((team) => team.name === name);
            if (teamInfo) {
              // Sanitize key components
              const sanitizedInitials = encodeURIComponent(teamInfo.initials);
              const sanitizedColor = encodeURIComponent(teamInfo.profileColor);
              const sanitizedName = teamInfo.name;

              const key = `${sanitizedName}`;
              const guessedCharacters = guessedWordData[name]
                .split(",")
                .map((char) => char.trim())
                .join(",");
              revealCharactersObject[key] = { revealedcharacters: guessedCharacters };
            }
          });

          // Update the crowd data with new question and answers
          await crowdRef.transaction(
            (currentCrowdData) => {
              if (!currentCrowdData) {
                currentCrowdData = [];
              }

              // Append new session data
              if (!currentCrowdData[0]) {
                currentCrowdData[0] = { questionsarray: [], participantsanwers: [] };
              }

              const questionsarray = currentCrowdData[0].questionsarray || [];
              const participantsanwers = currentCrowdData[0].participantsanwers || [];
              questionsarray.push({ correctanswer: correctAnswer, question });
              participantsanwers.push(revealCharactersObject);

              currentCrowdData[0] = {
                ...currentCrowdData[0],
                questionsarray,
                participantsanwers,
              };

              return currentCrowdData;
            },
            (error, committed) => {
              if (error) {
                console.error("Transaction failed:", error);
              } else if (committed) {
                console.log("Crowd data updated successfully.");
              } else {
                console.log("Transaction not committed.");
              }
            }
          );

          // Remove guessed word data from localStorage
          localStorage.removeItem("guessedWordData by participnat");
        } catch (error) {
          console.error("Error occurred:", error);
        }
      }

      if (
        !roundWinners.some(
          (winner) =>
            winner.round === roundIndex + 1 &&
            winner.team === (teamNames?.[teamIndex] || `Team ${teamIndex + 1}`)
        )
      ) {
        roundWinners.push({
          round: roundIndex + 1,
          team: teamNames?.[teamIndex] || `Team ${teamIndex + 1}`,
        });
        localStorage.setItem("roundWinners", JSON.stringify(roundWinners));
      }
    } catch (error) {
      console.error("Error in handleWin:", error);
    }
  };

  const handleDrawCondition = async () => {
    console.log("handleDrawCondition invoked");

    // Set state to show draw modal and prepare for the next round
    setIsDraw(true);
    setShowNextTurnModal(false);
    setParticipantsStartedAnswering(false);
    setShowDrawModal(true);

    try {

      const fullPath = window.location.pathname;
      const isCLParamPresent = fullPath.includes("m=cl");
      const isCRParamPresent = fullPath.includes("m=cr");
      console.log("Is m=cl param present:", isCLParamPresent);


      if (isCRParamPresent) {
        // Retrieve selected round details from localStorage
        const selectedRound = JSON.parse(localStorage.getItem("selectedRound"));
        if (!selectedRound || !selectedRound.question || !selectedRound.answer) {
          console.error("SelectedRound is missing required fields.");
          return;
        }

        const { question, answer: correctAnswer } = selectedRound;

        // Initialize Firebase database reference
        const db = firebase.database();
        const teamNamesRef = db.ref(`AppleTV/${code}/teamNames`);
        const crowdRef = db.ref(`AppleTV/${code}/crowd`);

        try {
          // Fetch team names and crowd data
          const [teamNamesSnapshot, crowdSnapshot] = await Promise.all([
            teamNamesRef.once("value"),
            crowdRef.once("value"),
          ]);

          const teamNamesData = teamNamesSnapshot.val();
          const crowdData = crowdSnapshot.val();

          if (!teamNamesData || !Array.isArray(teamNamesData)) {
            console.error("Invalid team names data.");
            return;
          }

          console.log("Crowd data retrieved:", crowdData);

          // Retrieve guessed word data from localStorage
          const guessedWordData =
            JSON.parse(localStorage.getItem("guessedWordData by participnat")) || {};

          // Extract connected students from crowd data
          if (crowdData[0] && crowdData[0].connectedstudents) {
            const extractedStudents = crowdData[0].connectedstudents.map((student) =>
              student.split("&")[0]
            );
            setconnectedStudent(extractedStudents);
            console.log("Connected students:", extractedStudents);
          }

          // Create reveal characters object for each team
          const revealCharactersObject = {};
          Object.keys(guessedWordData).forEach((name) => {
            const teamInfo = teamNamesData.find((team) => team.name === name);
            if (teamInfo) {
              // Sanitize key components
              const sanitizedInitials = encodeURIComponent(teamInfo.initials);
              const sanitizedColor = encodeURIComponent(teamInfo.profileColor);
              const sanitizedName = teamInfo.name;

              const key = `${sanitizedName}`;
              const guessedCharacters = guessedWordData[name]
                .split(",")
                .map((char) => char.trim())
                .join(",");
              revealCharactersObject[key] = { revealedcharacters: guessedCharacters };
            }
          });

          // Update the crowd data with new question and answers
          await crowdRef.transaction(
            (currentCrowdData) => {
              if (!currentCrowdData) {
                currentCrowdData = [];
              }

              // Append new session data
              if (!currentCrowdData[0]) {
                currentCrowdData[0] = { questionsarray: [], participantsanwers: [] };
              }

              const questionsarray = currentCrowdData[0].questionsarray || [];
              const participantsanwers = currentCrowdData[0].participantsanwers || [];
              questionsarray.push({ correctanswer: correctAnswer, question });
              participantsanwers.push(revealCharactersObject);

              currentCrowdData[0] = {
                ...currentCrowdData[0],
                questionsarray,
                participantsanwers,
              };

              return currentCrowdData;
            },
            (error, committed) => {
              if (error) {
                console.error("Transaction failed:", error);
              } else if (committed) {
                console.log("Crowd data updated successfully.");
              } else {
                console.log("Transaction not committed.");
              }
            }
          );

          // Remove guessed word data from localStorage
          localStorage.removeItem("guessedWordData by participnat");
        } catch (error) {
          console.error("Error occurred:", error);
        }
      }

      if (isCLParamPresent) {
        // Retrieve selected round details from localStorage
        const selectedRound = JSON.parse(localStorage.getItem("selectedRound"));
        if (!selectedRound || !selectedRound.question || !selectedRound.answer) {
          console.error("SelectedRound is missing required fields.");
          return;
        }

        const { question, answer: correctAnswer } = selectedRound;

        // Initialize Firebase database reference
        const db = firebase.database();
        const ref = db.ref(`AppleTV/${code}/teamNames`);

        // Define API URLs for ClassroomLeaderboard and Classroom data
        const apiUrl = `https://trivia-maker.firebaseio.com/ClassroomLeaderboard/${clid}.json`;
        const classroomUrl = `https://trivia-maker.firebaseio.com/Classroom/${clid}.json`;

        // Fetch current classroom data and team names
        const [currentDataResponse, teamNamesSnapshot] = await Promise.all([
          axios.get(classroomUrl),
          ref.once("value"),
        ]);

        const currentDataForClassroom = currentDataResponse.data;
        const teamNamesData = teamNamesSnapshot.val();

        if (!teamNamesData || !Array.isArray(teamNamesData)) {
          console.error("Invalid team names data.");
          return;
        }

        // Fetch the current ClassroomLeaderboard session
        const sessionResponse = await fetch(apiUrl);
        const sessionData = await sessionResponse.json();

        const currentSession = Array.isArray(sessionData)
          ? sessionData[sessionData.length - 1]
          : null;

        if (!currentSession) {
          console.error("Current session not found.");
          return;
        }

        // Retrieve guessed word data from localStorage
        const guessedWordData = JSON.parse(localStorage.getItem("guessedWordData by participnat")) || {};

        // Extract connected students from current session
        if (currentSession.connectedstudents) {
          const extractedStudents = currentSession.connectedstudents.map((student) =>
            student.split("&")[0]
          );
          setconnectedStudent(extractedStudents);
          console.log("Connected students:", extractedStudents);

          if (currentDataForClassroom && currentDataForClassroom.students) {
            // Update students' question attempts in the classroom data
            currentDataForClassroom.students.forEach((student) => {
              if (extractedStudents.includes(student.stuname)) {
                student.questionattempted = (student.questionattempted || 0) + 1;
              }
            });

            console.log("Updated students:", currentDataForClassroom.students);

            // Patch the updated student data to the Classroom database
            try {
              await fetch(classroomUrl, {
                method: "PATCH",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  students: currentDataForClassroom.students,
                }),
              });

              console.log("Updated student data successfully patched to Classroom.");
            } catch (error) {
              console.error("Error patching updated student data:", error);
            }
          }
        }

        // Create reveal characters object for each team
        const revealCharactersObject = {};
        Object.keys(guessedWordData).forEach((name) => {
          const teamInfo = teamNamesData.find((team) => team.name === name);
          if (teamInfo) {
            const key = `${teamInfo.initials}+${teamInfo.profileColor}+-+${teamInfo.name.replace(
              /\s+/g,
              "+"
            )}`;
            const guessedCharacters = guessedWordData[name]
              .split(",")
              .map((char) => char.trim())
              .join(",");
            revealCharactersObject[key] = { revealedcharacters: guessedCharacters };
          }
        });

        // Prepare the updated session data with the new answers
        const questionsarray = currentSession.questionsarray || [];
        const participantsanwers = currentSession.participantsanwers || [];
        questionsarray.push({ correctanswer: correctAnswer, question });
        participantsanwers.push(revealCharactersObject);

        const updatedSessionData = {
          ...currentSession,
          questionsarray,
          participantsanwers,
        };

        console.log("Final session data to patch:", updatedSessionData);

        // Send updated session data to the ClassroomLeaderboard API
        const patchResponse = await fetch(apiUrl, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            [`${sessionData.length - 1}`]: updatedSessionData,
          }),
        });

        if (!patchResponse.ok) {
          console.error("Failed to update session data:", patchResponse.statusText);
        } else {
          console.log("Question and answer added to the current session.");
        }

        // Remove guessed word data from localStorage
        localStorage.removeItem("guessedWordData by participnat");
      }



      // Find the current round index by comparing the word to guess
      const roundIndex = rounds.findIndex(
        (round) =>
          round.answer.trim().toLowerCase() === wordToGuess.trim().toLowerCase()
      );

      console.log("Current round index:", roundIndex);



      // Get round winners from localStorage
      const roundWinners = JSON.parse(localStorage.getItem("roundWinners")) || [];

      // Check if the draw already exists in the round winners array
      const alreadyExists = roundWinners.some(
        (winner) => winner.round === roundIndex + 1 && winner.team === "Draw"
      );

      if (!alreadyExists) {
        roundWinners.push({
          round: roundIndex + 1,
          team: "Draw",
        });
        localStorage.setItem("roundWinners", JSON.stringify(roundWinners));
      }

    } catch (error) {
      console.error("Error in handleDrawCondition:", error);
      alert("Error occurred while processing the draw condition: " + error.message);
    }
  };
  // Mock function to retrieve guessedWordbyparticipant from Firebase
  const getGuessedWordbyparticipantFromFirebase = async () => {
    try {
      const db = firebase.database();
      const ref = db.ref(`AppleTV/${code}`);
      const snapshot = await ref
        .child("guessedWordbyparticipant")
        .once("value");
      const data = snapshot.val() || [];
      console.log("Data fetched from Firebase:", data);
      return data;
    } catch (error) {
      console.error("Error fetching guessedWordbyparticipant:", error);
      return [];
    }
  };

  const updateGuessedWordArrayInFirebase = async (guessedWordArray) => {
    console.log("Updating guessedWord in Firebase:", guessedWordArray);
    const db = firebase.database();
    const ref = db.ref(`AppleTV/${code}`);
    await ref.child("guessedWord").set(guessedWordArray);
    console.log("GuessedWord updated successfully.");
  };

  const updateGuessedWordInFirebase = async (letter, result) => {
    const db = firebase.database();
    const ref = db.ref(`AppleTV/${code}`);
    ref.child("guessedWord").child(letter).set(result);
  };

  const removeGuessedWordFromFirebase = async () => {
    const db = firebase.database();
    const ref = db.ref(`AppleTV/${code}`);
    await ref.child("guessedWord").remove();
    console.log("guessedWord removed successfully from Firebase.");
  };
  const updateTeamInFirebase = async (teamIndex) => {
    const urlParams = new URLSearchParams(window.location.search);
    const mParam = urlParams.get("m");

    if (mParam === "cr" || window.location.pathname.includes("/m=cr") || window.location.pathname.includes("/m=cl")) {
      const code = localStorage.getItem("code");

      if (!code) {
        console.error("Code is not set in local storage.");
        return;
      }

      const currentteam = teamNames?.[teamIndex] || `Team ${teamIndex + 1}`;

      try {
        const response = await axios.get(
          `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`
        );

        const data = response.data;
        data.currentteam = currentteam; // Only update currentteam

        await axios.put(
          `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`,
          data
        );

        console.log("Team updated in Firebase");
      } catch (error) {
        console.error("Error updating team in Firebase:", error);
      }
    }
  };

  // Helper function to update team in Firebase
  // const updateTeamInFirebase = async (teamIndex) => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const mParam = urlParams.get("m");

  //   if (mParam === "cr" || window.location.pathname.includes("/m=cr")) {
  //     const code = localStorage.getItem("code");

  //     if (!code) {
  //       console.error("Code is not set in local storage.");
  //       return;
  //     }

  //     const command = "7001";
  //     const currentteam = teamNames[teamIndex];

  //     try {
  //       const response = await axios.get(
  //         `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`
  //       );

  //       const data = response.data;
  //       data.currentteam = currentteam;
  //       data.command = command;

  //       await axios.put(
  //         `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`,
  //         data
  //       );

  //       console.log("Team updated in Firebase");
  //     } catch (error) {
  //       console.error("Error updating team in Firebase:", error);
  //     }
  //   }
  // };
  useEffect(() => {
    // Restore game state from localStorage
    const savedWord = localStorage.getItem("wordToGuess");
    const savedGuessedLetters =
      JSON.parse(localStorage.getItem("guessedLetters")) || [];
    const savedWrongGuesses = Number(localStorage.getItem("wrongGuesses")) || 0;
    const savedCurrentTeam =
      Number(localStorage.getItem("currentTeam")) || null;
    const savedScore = JSON.parse(localStorage.getItem("score"));
    console.log(savedScore, "savedScore");
    if (savedWord) setWordToGuess(savedWord);
    if (savedGuessedLetters.length) setGuessedLetters(savedGuessedLetters);
    if (savedWrongGuesses >= 0) setWrongGuesses(savedWrongGuesses);
    if (savedCurrentTeam !== null) setCurrentTeam(savedCurrentTeam);
    // if (savedScore) setTeamScores({ team1: savedScore[0], team2: savedScore[1] });
  }, []);

  const updateDatabase = () => {
    if (code) {
      const db = firebase.database();
      const ref = db.ref(`AppleTV/${code}`);

      // Retrieve the guessedLetters from localStorage and parse it
      const guessedLetters = JSON.parse(
        localStorage.getItem("guessedLetters") || "[]"
      );

      // Update the guessedLetters and correctWord in the database
      ref.update({
        guessedLetters,
        correctWord: wordToGuess // Send the current word to participants
      });

      console.log('Updated Firebase with correctWord:', wordToGuess);
    }
  };

  useEffect(() => {
    // Save game state to localStorage
    localStorage.setItem("wordToGuess", wordToGuess);
    localStorage.setItem("guessedLetters", JSON.stringify(guessedLetters));
    localStorage.setItem("wrongGuesses", wrongGuesses);
    localStorage.setItem("currentTeam", currentTeam);
    localStorage.setItem("score", JSON.stringify(score));

    // Update the database after saving to localStorage
    updateDatabase();
  }, [wordToGuess, guessedLetters, wrongGuesses, currentTeam, score]);

  useEffect(() => {
    // Redirect to /splash if the game has ended
    if (
      !showWinModal &&
      !showDrawModal &&
      (wrongGuesses >= hangmanImages.length - 1 || winningTeam !== null)
    ) {
      window.localStorage.removeItem("wordToGuess");
      window.localStorage.removeItem("guessedLetters");
      window.localStorage.removeItem("wrongGuesses");
      window.localStorage.removeItem("currentTeam");
      window.localStorage.removeItem("score");

      updateDatabase(); // Ensure the final state is updated in the database

      onNavigate("splash");

    }
  }, [showWinModal, showDrawModal, wrongGuesses, winningTeam]);
  // useEffect(() => {
  //   updateDatabase();
  // }, [localStorage.getItem('guessedLetters')]);

  const handleTeamSelect = async (teamIndex) => {
    const urlParams = new URLSearchParams(window.location.search);

    if (window.location.pathname.includes("/m=cr") || window.location.pathname.includes("/m=cl")) {
      console.log("code:", code); // Check if code is correctly retrieved

      if (!code) {
        console.error("Code is not set in local storage.");
        return;
      }

      const command = "7001";
      const currentteam = teamNames?.[teamIndex] || `Team ${teamIndex + 1}`;
      console.log("currentteam:", currentteam); // Check if currentteam is correctly retrieved

      if (!currentteam) {
        console.error("Current team is not set.");
        return;
      }

      try {
        const response = await axios.get(
          `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`
        );

        console.log("Response:", response); // Check the response from the GET request

        const data = response.data;
        data.currentteam = currentteam;
        data.command = command;
        data.participantsStartedAnswering = true;
        console.log("Data to be posted:", data); // Check the data to be posted

        await axios.put(
          `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`,
          data
        );

        console.log("Data posted successfully");
      } catch (error) {
        console.error("Error posting data:", error);
      }
    } else {
      console.log(
        'mParam is not "cr" or not present in URL. Data will not be posted.'
      );
    }

    setCurrentTeam(teamIndex);
    setShowTeamSelectModal(false); // Close the team selection modal

  };
  // useEffect(() => {
  //   const updateDisplayWord = () => {
  //     if (isDraw) {
  //       // Show the full word when a draw occurs
  //       return wordToGuess.split("").join(" ");
  //     }
  //     // Otherwise, show guessed letters or underscores, but keep spaces intact
  //     const displayWord = wordToGuess
  //       .split("")
  //       .map((letter) => (letter === " " ? " " : guessedLetters.includes(letter) ? letter : "_"))
  //       .join(" ");
  //     return displayWord;
  //   };

  //   const updatedDisplayWord = updateDisplayWord();
  //   setDisplayWord(updatedDisplayWord);
  // }, [wordToGuess, guessedLetters, isDraw]);

  useEffect(() => {
    const updateDisplayWord = () => {
      if (isDraw) {
        // Show the full word when a draw occurs
        return wordToGuess.split("").join(" ");
      }
      // Otherwise, show guessed letters or underscores, but keep spaces and special characters intact
      const displayWord = wordToGuess
        .split("")
        .map((char) => {
          if (char === " ") return " "; // Keep spaces as is

          // Check for Arabic or English letters
          if (/[\u0600-\u06FFa-zA-Z]/.test(char)) {
            // Check if this character has been guessed (normalize for comparison)
            const normalizedChar = normalizeCharacter(char, currentLanguage);
            const isGuessed = guessedLetters.some(guessedLetter =>
              normalizeCharacter(guessedLetter, currentLanguage) === normalizedChar
            );
            return isGuessed ? char : "_"; // Show guessed letters or underscores
          }

          return char; // Show special characters as is
        })
        .join(" ");
      return displayWord;
    };

    const updatedDisplayWord = updateDisplayWord();
    setDisplayWord(updatedDisplayWord);
  }, [wordToGuess, guessedLetters, isDraw, currentLanguage]);
  // const displayWord = wordToGuess
  //   .split("")
  //   .map((letter) => (guessedLetters.includes(letter) ? letter : "_"))
  //   .join(" ");
  const wordWidth = displayWord.length * 30;

  // Split alphabet into two halves for display
  const halfLength = Math.ceil(alphabet.length / 2);
  const firstHalf = alphabet.slice(0, halfLength);
  const secondHalf = alphabet.slice(halfLength);

  const hexToRgba = (hex, opacity) => {
    hex = hex.replace(/^#/, "");
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };
  const lightenColor = (hex, percent) => {
    hex = hex.replace(/^#/, "");
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Calculate the adjustment based on percentage
    r = Math.min(255, Math.round(r + (255 - r) * percent));
    g = Math.min(255, Math.round(g + (255 - g) * percent));
    b = Math.min(255, Math.round(b + (255 - b) * percent));

    return `rgba(${r}, ${g}, ${b}, 1)`;
  };

  const backgroundColor1 = lightenColor(team1bgColor, 0.2); // Lighten by 80%
  const backgroundColor2 = lightenColor(team2bgColor, 0.2); // Lighten by 80%

  const handleHideModal = () => {
    const db = firebase.database();
    const ref = db.ref(`AppleTV/${code}`);
    ref
      .child("participantsStartedAnswering")
      .set(false)
      .then(() => {
        console.log("participantsStartedAnswering set to false");
        setParticipantsStartedAnswering(false);
      })
      .catch((error) => {
        console.error("Error updating participantsStartedAnswering:", error);
      });
  };

  // Function to handle "End" button click and update the database
  const handleEnd = () => {
    handleOpen();
    const db = firebase.database();
    const ref = db.ref(`AppleTV/${code}`);
    ref
      .child("participantsStartedAnswering")
      .set(false)
      .then(() => {
        console.log("participantsStartedAnswering set to false on end");
        setParticipantsStartedAnswering(false);
        return ref.child("command").set("7300");
        // Optionally, you can reset the participants here if needed:
        // Clears out participants list, setting up for new round if desired
      })
      .catch((error) => {
        console.error(
          "Error updating participantsStartedAnswering on end:",
          error
        );
      });
  };


  const onCloseNextturn = async () => {
    const command = "7001"; // Set command here
    const code = localStorage.getItem("code"); // Ensure code is available

    try {
      // Remove guessedWordbyparticipant data from Firebase
      const db = firebase.database();
      const ref = db.ref(`AppleTV/${code}`);
      await ref.child("guessedWordbyparticipant").remove();

      // Update command in Firebase as well
      const response = await axios.get(
        `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`
      );

      const data = response.data;
      data.command = command; // Set command here

      await axios.put(
        `https://trivia-maker-tv.firebaseio.com/AppleTV/${code}.json`,
        data
      );

      setParticipantsStartedAnswering(true);
      // Hide the modal
      setShowNextTurnModal(false);
    } catch (error) {
      console.error("Error removing guessedWordbyparticipant:", error);
    }
  };
  return (
    <>
      {isportrait ? (
        <>
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              fontSize: "1.5rem",
              fontWeight: "bolder",
              backgroundColor: "#27738e",
              color: "white",
              display: "flex",
              flexDirection: "column",
              padding: "1.5vh",
            }}
          >
            <span className="mt-2 mb-4 p-3 ">
              {" "}
              To view this game, you will need to place your device in landscape
              mode
            </span>

            <div style={{ padding: "1.5vh" }}>
              <img
                src={landscapeIcon}
                alt="landscapeIcon"
                height={200}
                className="rotate-icon"
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <BasicHeaderPlayScreen onNavigate={onNavigate} />
          <div className="main" style={backgroundStyle}>
            <div className="h-100 container-fluid d-flex flex-column Conatiner align-items-center">
              <Row className="w-100">
                <Col
                  xs={12}
                  md={4}
                  sm={4}
                  className={` d-flex justify-content-center align-items-center teamName`}
                  style={{ opacity: isPlayMode ? 0 : 1 }}
                >
                  {currentTeam === 0 && (
                    <div className="stars-container">
                      <img src={star} alt="star 1" className="starplay star1" />
                      <img src={star} alt="star 2" className="starplay star2" />
                      <img src={star} alt="star 3" className="starplay star3" />
                      <img src={star} alt="star 4" className="starplay star4" />
                      <img src={star} alt="star 5" className="starplay star5" />
                      <img src={star} alt="star 6" className="starplay star6" />
                      <img src={star} alt="star 7" className="starplay star7" />
                      <img src={star} alt="star 8" className="starplay star8" />
                    </div>
                  )}

                  <div
                    className={
                      currentTeam === 0
                        ? "Teamboxuiclass Teamboxuiclass-left"
                        : "inactive-team Teamboxuiclass-left"
                    }
                    style={{
                      backgroundColor: team1bgColor,
                      boxShadow: `0.5vw 6px 0px 0.3vw ${hexToRgba(
                        team1bgColor,
                        0.8
                      )}`,
                    }}
                    id="FirstTeam"
                  >
                    <div
                      className="teamnameclass"
                      style={{
                        backgroundColor: backgroundColor1,
                        borderRadius: "5px",
                      }}
                    >
                      {teamNames?.[0]?.length > 12 ? `${teamNames[0].slice(0, 10)}...` : (teamNames?.[0] || "Team 1")}
                    </div>
                    <div className="teamscorclass">
                      <span id="teamscoreid1">{score[0]}</span>{" "}
                      {/* Display team 1 score */}
                    </div>
                  </div>
                </Col>

                <Col
                  xs={12}
                  md={4}
                  sm={4}
                  className="thumbnail1 d-flex justify-content-center align-items-center"
                >
                  <img
                    id="imgid"
                    src={hangmanImages[wrongGuesses]}
                    alt="Game"
                    className=""
                  />
                </Col>

                <Col
                  xs={12}
                  md={4}
                  sm={4}
                  className={` d-flex justify-content-center align-items-center teamName`}
                  style={{ opacity: isPlayMode ? 0 : 1 }}
                >
                  {currentTeam === 1 && (
                    <div className="stars-container">
                      <img
                        src={star}
                        alt="star 1"
                        className="starplay starSecond1"
                      />
                      <img
                        src={star}
                        alt="star 2"
                        className="starplay starSecond2"
                      />
                      <img
                        src={star}
                        alt="star 3"
                        className="starplay starSecond3"
                      />
                      <img
                        src={star}
                        alt="star 4"
                        className="starplay starSecond4"
                      />
                      <img
                        src={star}
                        alt="star 5"
                        className="starplay starSecond5"
                      />
                      <img
                        src={star}
                        alt="star 6"
                        className="starplay starSecond6"
                      />
                      <img
                        src={star}
                        alt="star 7"
                        className="starplay starSecond7"
                      />
                      <img
                        src={star}
                        alt="star 8"
                        className="starplay starSecond8"
                      />
                    </div>
                  )}
                  <div
                    className={
                      currentTeam === 1
                        ? "Teamboxuiclass Teamboxuiclass-right"
                        : "inactive-team Teamboxuiclass-right"
                    }
                    style={{
                      backgroundColor: team2bgColor,
                      boxShadow: `0.5vw 6px 0px 0.3vw ${hexToRgba(
                        team2bgColor,
                        0.8
                      )}`,
                    }}
                    id="SecondTeam"
                  >
                    <div
                      className="teamnameclass"
                      style={{
                        backgroundColor: backgroundColor2,
                        borderRadius: "5px",
                      }}
                    >
                      {teamNames?.[1]?.length > 12 ? `${teamNames[1].slice(0, 10)}...` : (teamNames?.[1] || "Team 2")}
                    </div>
                    <div className="teamscorclass">
                      <span id="teamscoreid2">{score[1]}</span>{" "}
                      {/* Display team 2 score */}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="w-100 mt-2">
                <Col xs={12} className="d-flex justify-content-center">
                  <input
                    style={{
                      backgroundColor: buttonColor,
                      color: fontColor,
                      textAlign: "center",
                      width: `${wordWidth}px`,
                      border: "none", // Optional: to remove border if not needed
                      fontSize: "16px", // Optional: adjust font size as needed
                      letterSpacing: "2px", // Optional: add spacing between letters if needed
                    }}
                    type="text"
                    value={displayWord}
                    readOnly
                    className={`word-input ${currentLanguage === 'ar' ? 'arabic' : ''}`}
                  />
                </Col>
              </Row>

              <Row className="w-100 mt-4">
                <Col xs={12} className="d-flex p-0 justify-content-center">
                  {firstHalf.map((letter) => (
                    <Button
                      style={{ backgroundColor: buttonColor, color: fontColor }}
                      key={letter}
                      variant="outline-light"
                      className={`alphabet-button ${currentLanguage === 'ar' ? 'arabic' : ''}`}
                      onClick={() => handleLetterClick(letter)}
                      disabled={
                        guessedLetters.includes(letter) ||
                        wrongGuesses >= hangmanImages.length - 1
                      }
                    >
                      {letter}
                    </Button>
                  ))}
                </Col>
              </Row>
              {/* <Button variant="contained" onClick={handleOpen}>
        Show Guessed Words
      </Button> */}
              <GuessedWordsModal open={modalOpen} onClose={handleClose} guessedWords={guessedWords} />

              <Row className="w-100">
                <Col
                  xs={12}
                  className="d-flex justify-content-center flex-wrap"
                >
                  {secondHalf.map((letter) => (
                    <Button
                      style={{ backgroundColor: buttonColor, color: fontColor }}
                      key={letter}
                      variant="outline-light"
                      className={`alphabet-button ${currentLanguage === 'ar' ? 'arabic' : ''}`}
                      onClick={() => handleLetterClick(letter)}
                      disabled={
                        guessedLetters.includes(letter) ||
                        wrongGuesses >= hangmanImages.length - 1
                      }
                    >
                      {letter}
                    </Button>
                  ))}
                </Col>
              </Row>

              {/* Modal for Team Selection */}
              <Modal
                className="custom-modal justify-content-center modal-dialog-centered"
                show={showTeamSelectModal}
                onHide={() => setShowTeamSelectModal(false)}
              >
                <Modal.Header className="d-flex mb-4 justify-content-center">
                  <span className="SelectTeamText">{localization.select_team}</span>
                </Modal.Header>
                <Modal.Body className="team-select-modal-body">
                  <Row>
                    <Col xs={12} className="d-flex justify-content-center">
                      <div className="select-team-container d-flex">
                        <Button
                          variant="dark"
                          className="me-2 selectTeam"
                          onClick={() => handleTeamSelect(0)}
                          disabled={teamNames?.length < 1}
                        >
                          {teamNames?.[0] || "Team 1"}
                        </Button>
                        <Button
                          variant="dark"
                          className="selectTeam"
                          onClick={() => handleTeamSelect(1)}
                          disabled={teamNames?.length < 2}
                        >
                          {teamNames?.[1] || "Team 2"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
              </Modal>

              {/* playalone modal */}
              <Modal
                className="custom-name-modal"
                show={showplayaloneModal}
                onClick={() => setshowplayaloneModal(false)}
                onHide={() => setshowplayaloneModal(false)}
              >
                <Modal.Body className="m-4 playaloneText">
                  Guess the correct letters to save Mr. Stick.
                </Modal.Body>
              </Modal>
              {/* Modal for Win */}
              <Modal
                className="custom-win-modal"
                show={showWinModal}
                onHide={() => setShowWinModal(false)}
              >
                <Modal.Body className="m-4 SelectTeamText d-flex justify-content-around">
                  {isPlayMode
                    ? "You won!"
                    : `${teamNames?.[winningTeam] || "Winner"} has won!`}
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={nextIcon}
                      alt="nextIcon"
                      height={50}
                      width={50}
                      onClick={() => setShowWinModal(false)}
                      style={{ cursor: "pointer" }}
                    />
                    <h7
                      className="nextText"
                      style={{
                        display: "block",
                        fontSize: "20px",
                        marginTop: "5px",
                      }}
                    >
                      {localization.next}
                    </h7>
                  </div>
                </Modal.Body>
              </Modal>

              {/* Modal for Draw */}
              <Modal
                className="custom-win-modal drawModal"
                show={showDrawModal}
                onHide={() => setShowDrawModal(false)}
              >
                <Modal.Body className="m-4 SelectTeamText d-flex justify-content-around">
                  {/* It's a Draw! */}
                  {isPlayMode
                    ? `Unfortunely, you didn't solve it this time. `
                    : "It's a draw!"}
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={nextIcon}
                      alt="nextIcon"
                      height={50}
                      width={50}
                      onClick={() => setShowDrawModal(false)}
                      style={{ cursor: "pointer" }}
                    />
                    <h7
                      style={{
                        display: "block",
                        fontSize: "20px",
                        marginTop: "5px",
                      }}
                    >
                      {localization.next}
                    </h7>
                  </div>
                </Modal.Body>
              </Modal>

              {/* modal for result */}
              {showResultModal && (
                <Modal>
                  <Modal.Header closeButton>
                    <Modal.Title>Guessed Words Result</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {guessedWords.map((word, index) => (
                      <div key={index}>
                        <span>
                          {word.word}: {word.percentage}%
                        </span>
                      </div>
                    ))}
                  </Modal.Body>
                </Modal>
              )}
              {/* Next Turn Modal */}
              <Modal
                className="custom-modal justify-content-center modal-dialog-centered"
                show={showNextTurnModal}
                onHide={onCloseNextturn} // Call the function here
              >
                <Modal.Body className="m-4">
                  <div className="d-flex  justify-content-between align-item-end">
                    <h5 className="playaloneText mb-4 ">{localization.next_turn}</h5>
                    <IconButton
                      onClick={onCloseNextturn} // Call the function on close button click
                      sx={{ color: "white" }}
                      className="mb-3 "
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                  <p>It's now {nextTeamName}'s turn!</p>
                </Modal.Body>
              </Modal>

              {/* showRemaining participants */}
              {participantsStartedAnswering && (
                <div className="modal notification-box">
                  <div className="modal-content-remaining" style={{
                    width:
                      participants.length > 0
                        ? "15%"
                        : "10%",
                    // minWidth: 120,
                    // maxWidth: 300,
                    // margin: "0 auto"
                  }}>
                    {/* Remaining Count Section */}
                    <div
                      className="remainingcountdiv"
                      id="remainingcountdiv0"
                      style={{ cursor: "pointer" }}
                    >
                      {participants.length > 0 ? (
                        participants.length > 2 ? (
                          <>
                            {participants
                              .slice(0, 2)
                              .map((participant, index) => (
                                <span
                                  key={index} // Add a unique key for each participant
                                  className="remainingusersinitial"
                                  id={`remaininginitial${index}`}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  style={{
                                    display: "flex",
                                    background: "rosybrown",
                                    color: "black",
                                  }}
                                  data-original-title={participant.name} // Change tooltip to display participant's name
                                >
                                  {participant.initials}
                                </span>
                              ))}
                            <span className="remainingusersinitial">
                              +{participants.length - 2}
                            </span>
                          </>
                        ) : (
                          participants.map((participant, index) => (
                            <span
                              key={index} // Add a unique key for each participant
                              className="remainingusersinitial"
                              id={`remaininginitial${index}`}
                              data-toggle="tooltip"
                              data-placement="top"
                              style={{
                                display: "flex",
                                background: "rosybrown",
                                color: "black",
                              }}
                              data-original-title={participant.name} // Change tooltip to display participant's name
                            >
                              {participant.initials}
                            </span>
                          ))
                        )
                      ) : (
                        <span
                          id="remainigprcount"
                          style={{ display: "block", color: "white" }}
                        >
                          {localization.all_done}
                        </span>
                      )}
                      &nbsp; &nbsp;
                      <br />
                      {participants.length > 0 && (
                        <span
                          id="remainigprcount"
                          style={{ display: "block", color: "white" }}
                        >
                          {localization.left_to_answer}
                        </span>
                      )}
                      &nbsp; &nbsp;
                      <div>
                        {/* Uncomment if you want to add a close button */}
                        {/* <span className="closeparticipant" onClick={handleHideModal}> &times; </span> */}
                      </div>
                    </div>
                    <div className="endRemaining">
                      <button
                        type="button"
                        className="btn btn-danger"
                        style={{
                          position: "absolute",
                          bottom: 10,
                          right: 10,
                        }}
                        onClick={handleEnd} // Use the function defined in your component
                      >
                        {localization.end}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default HangManPlayScreen;
